(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .factory('SemeaduraAfericaoService', SemeaduraAfericaoService);

  SemeaduraAfericaoService.$inject = [
    '$http',
    'RestService'
  ];

  // eslint-disable-next-line max-lines-per-function
  function SemeaduraAfericaoService($http, RestService) {
    const service = {
      list,
      summarized
    };

    function list(params = {}) {
      params.tipo_semeadura_afericao = params.tipo;
      params.tipo = 'semeadura_afericao';
      const url = `${SERVER}v1/operacoes_campo/visitas`;
      return $http.get(url, { params });
    }

    function summarized(params) {
      params = paramsToSend(params);
      const url = `${SERVER}v1/semeadura_afericoes/summarized`;
      return RestService.getFromUrl(url, params).then(function(data) {
        data.data.forEach(function(item) {
          item.objeto = JSON.parse(item.objeto || null);
        });
        return data;
      });
    }

    function paramsToSend(params) {
      const newParams = {};
      Object.entries(params).forEach(([key, value]) => {
        if (typeof value === 'string' || value instanceof Date) {
          newParams[key] = value;
        } else {
          newParams[key] = _.get(value, 'id');
        }
      });
      return newParams;
    }

    return service;
  }
}());
